import { Selector } from '@ngxs/store';
import { UserDto } from 'src/app/generated/backend/models';
import { UserState } from './user.state';
import { AuthStage, UserStateModel } from './user.state-model';

export class UserSelectors {
  @Selector([UserState])
  static login(state: UserStateModel): UserDto | null {
    return state.user;
  }

  @Selector([UserState])
  static loggedIn(state: UserStateModel): boolean {
    return !!state.user?.token && state.authStage === AuthStage.Authenticated;
  }

  @Selector([UserState])
  static token(state: UserStateModel): string | null {
    return state.user?.token || null;
  }

  @Selector([UserState])
  static loading(state: UserStateModel): boolean {
    return state.loading;
  }

  @Selector([UserState])
  static error(state: UserStateModel): boolean {
    return state.error;
  }

  @Selector([UserState])
  static authStage(state: UserStateModel): AuthStage {
    return state.authStage;
  }
}
